import React from 'react'
import Navbar from '../components/Navbar'
import Hero from './Home/Hero'
import "./Home/Home.css";
import { FaStar, FaRegHeart, FaArrowUp } from "react-icons/fa";
import "./TopStays.css";
import bannerImage from "../assets/GettyImages-174105711 1.png"

function AdminHome() {
    const generateMockStays = (count) => {
  const categories = ["Beach Hotel", "Village Stay", "Resort", "City Hotel", "Eco Lodge"];
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `${categories[i % categories.length]} ${i + 1}`,
    image: `https://picsum.photos/300/200?random=${i + 1}`,
    reviews: `${Math.floor(Math.random() * 200)} reviews`,
    rating: (Math.random() * 2 + 3).toFixed(1),
    price: `$${Math.floor(Math.random() * 200 + 50)}/night`,
  }));
};




  return (
    <div>
       <Navbar/>
       <Hero/>
        {/* Features */}
      <section className="features">
        <div className="feature border">
          <h3>Traveler</h3>
          <p>
            Search, book, and manage tours, hotels, and visas while earning coins and sharing travel experiences.
          </p>
        </div>
        <div className="feature border">
          <h3>Guide</h3>
          <p>
            Create and manage tour listings, set availability, receive bookings, chat with travelers, and withdraw earnings.
          </p>
        </div>
        <div className="feature border">
          <h3>Hotel Owner</h3>
          <p>
            List and manage rooms, control availability, handle bookings, respond to guest messages, and track earnings.
          </p>
        </div>
         <div className="feature">
          <h3>Admin</h3>
          <p>
            Approve listings and registrations, 
        manage content, monitor platform activity, 
        and handle payments & user support.
          </p>
        </div>
      </section>
      <section className="section-container">
        <h2 className="section-title">
            Where Every Click Connects You to a Real Story.
        </h2>
        <p className="section-description">
          On Soloway, every booking is more than a transaction — it’s a connection. Discover authentic Sri Lankan stays, tours, and services while supporting 
local guides and hosts, creating meaningful experiences, and making every journey part of a bigger story.
        </p>
      </section>
      <section className="top-stays">
      {/* Header */}
      <div className="top-stays-header">
        <h2>Top stays in Sri Lanka</h2>
        <div className="sort-box">
          <label>Sort by:</label>
          <select>
            <option>Recommended</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
            <option>Top Rated</option>
          </select>
        </div>
      </div>

      {/* Categories */}
      <div className="categories">
        <button>Walking Tours</button>
        <button>Night Tours</button>
        <button>Guide</button>
        <button>Culture & History</button>
        <button>Hotels</button>
      </div>

      {/* Stays Grid */}
<div className="stays-grid">
  {generateMockStays(12).map((stay) => (
    <div className="stay-card" key={stay.id}>
      <div className="stay-img">
        <img src={stay.image} alt={stay.name} />
        <FaRegHeart className="fav-icon" />
      </div>
      <div className="stay-info">
        <h3>{stay.name}</h3>
        <p>{stay.reviews}</p>
        <div className="stars">
          {Array.from({ length: 5 }).map((_, i) => {
            const fullStar = i < Math.floor(stay.rating);
            const halfStar = !fullStar && i < stay.rating;
            return (
              <span key={i}>
                {fullStar ? <FaStar className="star" /> : halfStar ? <FaStar className="star-half" /> : <FaStar className="star-empty" />}
              </span>
            );
          })}
        </div>
        <p className="price">{stay.price}</p>
        <button className="go-btn">
         <FaArrowUp />
        </button>
      </div>
    </div>
  ))}
</div>     
    </section>
    <section className="top-stays">
    <div className="top-stays-header">
        <h2>Guides Who Bring Sri Lanka to Life</h2>
        <div className="sort-box">
          <label>Sort by:</label>
          <select>
            <option>Recommended</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
            <option>Top Rated</option>
          </select>
        </div>
      </div>

          {/* Stays Grid */}
<div className="stays-grid">
  {generateMockStays(12).map((stay) => (
    <div className="stay-card" key={stay.id}>
      <div className="stay-img">
        <img src={stay.image} alt={stay.name} />
              </div>
      <div className="stay-info">
        <h3>{stay.name}</h3>
        <p>{stay.reviews}</p>
        <div className="stars">
          {Array.from({ length: 5 }).map((_, i) => {
            const fullStar = i < Math.floor(stay.rating);
            const halfStar = !fullStar && i < stay.rating;
            return (
              <span key={i}>
                {fullStar ? <FaStar className="star" /> : halfStar ? <FaStar className="star-half" /> : <FaStar className="star-empty" />}
              </span>
            );
          })}
        </div>
        <p className="price">{stay.price}</p>       
      </div>
    </div>
  ))}
</div>     
<section/>
<div className="divider-with-button">
  <span className="line"></span>
  <button className="show-more-btn">Show More</button>
  <span className="line"></span>
</div>  

<div className="banner-image-container">
  <img src={bannerImage} alt="Traveler" className="banner-image" />
  <div className="banner-overlay-content">
    <h1 className="banner-overlay-title">Soloway</h1>
    <button className="banner-overlay-btn">See all tickets & tours</button>
  </div>
</div>



</section>
</div>
  )
}

export default AdminHome